export default __webpack_public_path__ + "static/media/lp-sec04_ttl.435101e6.png";